import { defineMessages } from 'react-intl';

export const scope = 'app.components.StyledSelect';

export default defineMessages({
  clearAllValues: {
    defaultMessage: 'Clear all',
    description: 'Accessible name for the control that empties a multi-select',
    id: `${scope}.clearAllValues`,
  },
  clearValue: {
    defaultMessage: 'Clear selection',
    description: 'Accessible name for the control that empties a single select',
    id: `${scope}.clearValue`,
  },
  noOptionsMessage: {
    defaultMessage: 'No options available',
    id: `${scope}.noOptionsMessage`,
  },
  placeholder: {
    defaultMessage: 'Please select...',
    id: `${scope}.placeholder`,
  },
  removeValue: {
    defaultMessage: 'Remove {label}',
    description: 'Accessible name for the button on a chip that drops that one value',
    id: `${scope}.removeValue`,
  },
});
